import { NotesField } from "common/components/jobFields/NotesField";
import {
  AssociatedTitleField,
  ATSIdField,
  BillingTierField,
  JobDepartmentField,
  JobGroupField,
  JobHiringManagerField,
  JobLocationField,
  JobOriginalOpeningsField,
  JobRecruiterField,
  JobTitleField,
  MaxPayField,
  MinPayField,
  RecruitingStartDateField,
  SecondaryATSIdField,
} from "common/components/jobFields";
import DisplayUDF from "../features/clients/details/userDefinedFields/displayUdf";

const jobUdfToField = (udf) =>
  udf.map((field) => ({
    key: `udf-${field.id}`,
    type: field.fieldType?.type?.toLowerCase() || "text",
    span: 12,
    udfData: field,
    isUDF: true,
    component: DisplayUDF,
    getProps: (context) => ({
      isFormItem: context.isFormItem,
      title: field.label,
      fieldTypeId: field.fieldTypeId,
      udfId: field.id,
      isRequired: !!field.isRequired,
      form: context.form,
      options: field.udfMultiValueFieldTypeVal?.length
        ? field.udfMultiValueFieldTypeVal
        : [],
      disabled: context.disabled,
      style: context.style,
      extraLabel: context.extraLabel,
    }),
  }));

export const getDefaultJobFields = (udf = []) => [
  {
    key: "recruitingStartDate",
    span: 12,
    component: RecruitingStartDateField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled || (!!context.editData && !context.isDuplicate),
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "title",
    span: 12,
    component: JobTitleField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "billingTier",
    span: 12,
    component: BillingTierField,
    getProps: (context) => ({
      disabled: context.disabled,
      jobTiers: context.jobTiers,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "associatedTitle",
    span: 12,
    component: AssociatedTitleField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      jobTiers: context.jobTiers,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "originalOpenings",
    span: 12,
    component: JobOriginalOpeningsField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled || (!!context.editData && !context.isDuplicate),
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "recruiters",
    span: 12,
    component: JobRecruiterField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      users: context.users?.Recruiter || [],
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "jobLocation",
    span: 12,
    component: JobLocationField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      lookupTables: context.lookupTables,
      clientId: context.clientId,
      editData: context.editData,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "hiringManagers",
    span: 12,
    component: JobHiringManagerField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      users: context.users?.["Hiring Manager"] || [],
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "atsId",
    span: 12,
    component: ATSIdField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "secondaryAtsId",
    span: 12,
    component: SecondaryATSIdField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "jobDepartment",
    span: 12,
    component: JobDepartmentField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      lookupTables: context.lookupTables,
      clientId: context.clientId,
      editData: context.editData,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "jobGroup",
    span: 12,
    component: JobGroupField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      lookupTables: context.lookupTables,
      clientId: context.clientId,
      editData: context.editData,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "minPay",
    span: 12,
    component: MinPayField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  {
    key: "maxPay",
    span: 12,
    component: MaxPayField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
  ...jobUdfToField(udf),
  {
    key: "notes",
    fixed: true,
    span: 24,
    component: NotesField,
    getProps: (context) => ({
      form: context.form,
      disabled: context.disabled,
      isFormItem: context.isFormItem,
      extraLabel: context.extraLabel,
      style: context.style,
    }),
  },
];
